module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study"
  }, [_c('div', {
    ref: "header",
    staticClass: "case-study__header"
  }, [_c('close-button')], 1), _vm._v(" "), _c('div', {
    ref: "scrollZone",
    staticClass: "case-study__scroll-zone"
  }, [_c('div', {
    ref: "pane",
    staticClass: "case-study__pane"
  }), _vm._v(" "), _c('div', {
    ref: "contentBackground",
    staticClass: "case-study-content-background"
  }, [_c('div', {
    ref: "content",
    staticClass: "case-study__content case-study__row"
  }, [_c('div', {
    ref: "infos",
    staticClass: "case-study__infos"
  }, [_c('div', {
    staticClass: "case-study__info"
  }, [_c('div', {
    staticClass: "case-study__info__title"
  }, [_vm._v("Context")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__info__text"
  }, [_vm._v(_vm._s(_vm.slide.context))])]), _vm._v(" "), _c('div', {
    staticClass: "case-study__info"
  }, [_c('div', {
    staticClass: "case-study__info__title"
  }, [_vm._v("Role")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__info__text"
  }, [_vm._v(_vm._s(_vm.slide.role))])]), _vm._v(" "), _c('div', {
    staticClass: "case-study__info"
  }, [_c('div', {
    staticClass: "case-study__info__title"
  }, [_vm._v("Year")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__info__text"
  }, [_vm._v(_vm._s(_vm.slide.period))])])]), _vm._v(" "), _c('div', {
    staticClass: "case-study__intro case-study__row"
  }, [_c('div', {
    staticClass: "case-study__title"
  }, [_vm._v("Presentation")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__intro__text"
  }, [_vm._v(_vm._s(_vm.slide.description))]), _vm._v(" "), (_vm.slide.url !== '') ? _c('link-button', {
    attrs: {
      "url": _vm.slide.url
    }
  }) : _vm._e()], 1), _vm._v(" "), _c(_vm.projectName, {
    tag: "component"
  })], 1)]), _vm._v(" "), _c('next-button')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e56c5f04!./~/vue-loader/lib/selector.js?type=template&index=0!./src/spa/CaseStudy/CaseStudy.vue
// module id = 283
// module chunks = 0